// extracted by css-extract-rspack-plugin
var _1 = "z3Hl04dsekEbYlFK";
var _2 = "JZEJX2Zvn5AUv0Do";
export { _1 as "text", _2 as "underline" }
